import { render } from "./AboutHP.vue?vue&type=template&id=42af427b&scoped=true"
import script from "./AboutHP.vue?vue&type=script&lang=js"
export * from "./AboutHP.vue?vue&type=script&lang=js"

import "./AboutHP.vue?vue&type=style&index=0&id=42af427b&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42af427b"]])

export default __exports__